module.exports = __webpack_public_path__ + "media/images/front/thumb3-8696a1d116ca08ccfbb60b8e91ad369a.jpg";